import { render } from "./InfoPageView.vue?vue&type=template&id=54a6d615&scoped=true"
import script from "./InfoPageView.vue?vue&type=script&lang=js"
export * from "./InfoPageView.vue?vue&type=script&lang=js"

import "./InfoPageView.vue?vue&type=style&index=0&id=54a6d615&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a6d615"]])

export default __exports__